import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import ColorBg from '../global/ColorBg';
import VideoPlayer from '../global/VideoPlayer';
import WebFrame from '../global/WebFrame';
import { hasFrame, heroContainer, mediaWrapper } from './Hero.module.scss';

const Hero = ({ heroMedia }) => {
  const { background_color, hero_image, frame, video_link, video_link_local } = heroMedia;
  return (
    <div className={`bgWidthTrigger pageGrid ${heroContainer}`}>
      <ColorBg bgColor={background_color} />
      <div
        className={`scrollFastHero gridAllColumns ${mediaWrapper} ${
          frame ? hasFrame : ''
        } `}
      >
        <WebFrame
          webFrame={frame}
          aspectRatio={1.78}
          wrapperClass={`rounded3xl`}
        >
          {video_link ? (
            <VideoPlayer
              cover={hero_image}
              url={video_link}
              localVideoUrl={video_link_local}
              autoplay={true}
              wrapperClass={`sixteenNineBox`}
            />
          ) : (
            <div className={`sixteenNineBox`}>
              <div className={`mediaBoxInner`}>
                <GatsbyImage
                  image={getImage(hero_image?.localFile)}
                  alt={hero_image?.alternativeText ?? ''}
                />
              </div>
            </div>
          )}
        </WebFrame>
      </div>
    </div>
  );
};
export default Hero;
